if (!customElements.get('clinical-standard-tabs')) {
  class ClinicalStandardTabs extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.cst__item'));
      this.triggers = Array.from(this.querySelectorAll('.cst__trigger'));
      this.mediaItems = Array.from(this.querySelectorAll('.cst__media-item'));

      if (!this.triggers.length) return;

      this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => this.activateItem(index));
        trigger.addEventListener('keydown', (event) => this.onKeyDown(event, index));
      });

      const initialIndex = this.triggers.findIndex(
        (trigger) => trigger.getAttribute('aria-expanded') === 'true'
      );
      this.activateItem(initialIndex >= 0 ? initialIndex : 0);
    }

    activateItem(index) {
      this.activeIndex = index;

      this.items.forEach((item, itemIndex) => {
        const isActive = itemIndex === index;
        const trigger = this.triggers[itemIndex];
        const panel = item.querySelector('.cst__panel');

        item.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');

        if (panel == null) return;

        if (isActive == true) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      this.mediaItems.forEach((media, mediaIndex) => {
        media.classList.toggle('is-active', mediaIndex === index);
      });
    }

    onKeyDown(event, currentIndex) {
      let nextIndex = currentIndex;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        nextIndex = (currentIndex + 1) % this.triggers.length;
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        nextIndex = (currentIndex - 1 + this.triggers.length) % this.triggers.length;
      } else if (event.key === 'Home') {
        event.preventDefault();
        nextIndex = 0;
      } else if (event.key === 'End') {
        event.preventDefault();
        nextIndex = this.triggers.length - 1;
      } else {
        return;
      }

      this.activateItem(nextIndex);
      this.triggers[nextIndex].focus();
    }
  }

  customElements.define('clinical-standard-tabs', ClinicalStandardTabs);
}
